import { RefObject } from 'react'
import { useHoverDirty } from 'react-use'

/**
 * Temporary fix for react-use's useHoverDirty so that it works with React 19
 * without any TypeScript issues.
 *
 * See https://github.com/streamich/react-use/issues/2612 for more context.
 *
 * @todo Make hook redundant once issue is fixed upstream in react-use.
 */
export function useIsHovered<T = HTMLElement>(
  ref: RefObject<T | null>,
  enabled?: boolean,
) {
  return useHoverDirty(ref as RefObject<Element>, enabled)
}
